import React from "react";
import { BsFilterLeft } from "react-icons/bs";
import FormGeneric from "../form/form-generic";
import AppButton from "../button/app-button";
import "./filter-panel.css";

const FilterPanel = ({
    title = "Filtros",
    formId = "filter-panel-form",
    formFields = [],
    position = "left",
    onSubmit,
    onClear,
    submitLabel = "Aplicar Filtro",
    clearLabel = "Limpar filtros",
    className = "",
    errors = {},
    onFieldChange,
}) => {
    return (
        <aside
            className={[
                "filter-panel",
                `filter-panel--${position}`,
                className
            ].filter(Boolean).join(" ")}
        >
            <header className="filter-panel__header">
                <BsFilterLeft />
                <strong>{title}</strong>
            </header>

            <div className="filter-panel__body">
                <FormGeneric
                    formId={formId}
                    formFields={formFields}
                    errors={errors}
                    onSubmit={onSubmit}
                    onFieldChange={onFieldChange}
                />
            </div>

            <footer className="filter-panel__footer">
                <AppButton
                    type="submit"
                    form={formId}
                    fullWidth
                    className="filter-panel__submit-button"
                >
                    {submitLabel}
                </AppButton>

                {onClear && (
                    <AppButton
                        type="button"
                        className="filter-panel__clear-button"
                        onClick={onClear}
                    >
                        {clearLabel}
                    </AppButton>
                )}
            </footer>
        </aside>
    );
};

export default FilterPanel;